export enum CodeMirrorThemes {
    Transformer = 'transformer_theme',
    GenAI = 'transformer_theme'
}
